{
  "deselectedItem": "{item} ikke valgt.",
  "select": "Vælg",
  "selectedAll": "Alle elementer valgt.",
  "selectedCount": "{count, plural, =0 {Ingen elementer valgt} one {# element valgt} other {# elementer valgt}}.",
  "selectedItem": "{item} valgt."
}
